import { registerPlugin } from '@capacitor/core';
const SipPhoneControl = registerPlugin('SipPhoneControl', {
    web: () => import('./web').then(m => new m.SipPhoneControlWeb()),
});
export { SipEvent, } from './definitions';
export { SipPhoneControl };
//# sourceMappingURL=index.js.map